<template>
  <div class="container ipdoc">
    <IpDocMd class="markdown-body"></IpDocMd>
  </div>
</template>

<script>
import "github-markdown-css/github-markdown.css";
import "highlight.js/styles/github.css";
import IpDocMd from "./ip定位服务文档.md";
export default {
  name: "IpDoc",
  components: { IpDocMd },
};
</script>

<style lang="less" scoped>
.ipdoc {
  margin: 30px auto;
  background-color: #fff;
  padding: 10px 20px;
}
</style>